import { Injectable } from "@angular/core";
import { Action } from '@ngrx/store';

import { ToastEvents } from "../elements/toast/toast.events";
import { Observable, of } from "rxjs";
import { ToastEffectActions } from "../store/actions";
import { ToastMessage } from "../models/toast-models";

@Injectable()
export class SuccessService {
    public runSuccessAction$(title: string, description: string): Observable<Action<string>> {
        ToastEvents.dispatchSuccess(title, description);
        // ToastEffectActions.showSuccessMessage({
        //       title: title,
        //       message: description,
        //     } as ToastMessage)

        return of(ToastEffectActions.messageInvoked());
    }

    public dispatchSuccess(title: string, description: string): void {
        ToastEvents.dispatchSuccess(title, description);
    }
}
